import { render } from "./RequirementUserAvatar.vue?vue&type=template&id=6473c5ca&scoped=true"
import script from "./RequirementUserAvatar.vue?vue&type=script&lang=js"
export * from "./RequirementUserAvatar.vue?vue&type=script&lang=js"

import "./RequirementUserAvatar.vue?vue&type=style&index=0&id=6473c5ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6473c5ca"]])

export default __exports__